import React, { useState, useEffect } from "react";
import BuilderFilter from "./BuilderFilter";
import BuilderCondition from "./BuilderCondition";

const BuilderDefinition = ({
  componentDefinition,
  setUpdatedComponent,
  toUpdate = true,
}) => {
  const [componentDefinitionData, setComponentDefinitionData] = useState(null);
  const [functionDefinition, setFunctionDefinition] = useState(null);
  const [filterDefinition, setFilterDefinition] = useState(null);
  const [conditionDefinition, setConditionDefinition] = useState(null);
  useEffect(() => {
    if (
      componentDefinition &&
      JSON.stringify(componentDefinition) !==
        JSON.stringify(componentDefinitionData)
    ) {
      setComponentDefinitionData(componentDefinition);
    }
  }, [componentDefinition]);
  useEffect(() => {
    if (componentDefinitionData) {
      if (
        componentDefinitionData.function &&
        componentDefinitionData.function === "FILTER"
      ) {
        setFunctionDefinition("FILTER");
        setFilterDefinition(componentDefinitionData.filter);
        setConditionDefinition(null);
      }
      if (
        componentDefinitionData.function &&
        (componentDefinitionData.function === "AND" ||
          componentDefinitionData.function === "OR")
      ) {
        setFunctionDefinition(componentDefinitionData.function);
        setConditionDefinition(componentDefinitionData.conditions);
        setFilterDefinition(null);
      }
    }
  }, [componentDefinitionData]);

  const setUpdatedDefinitionFunction = (data) => {
    if (data && toUpdate) {
      setUpdatedComponent("definition", data);
    }
  };

  const updateConditionInDefinition = (data) => {
    if (data) {
      setComponentDefinitionData(data);
      setUpdatedDefinitionFunction(data);
    }
  };
  return (
    <React.Fragment>
      {filterDefinition && (
        <BuilderFilter
          filterDetail={filterDefinition}
          insideCondition={false}
          setFilterDefinition={setUpdatedDefinitionFunction}
          setfilterToCondition={updateConditionInDefinition}
          remove_filter_inside_condition={null}
          toUpdate={toUpdate}
        />
      )}
      {functionDefinition && conditionDefinition && (
        <BuilderCondition
          conditionData={componentDefinitionData}
          insideCondition={false}
          setFilterDefinition={setUpdatedDefinitionFunction}
          setConditionToFilter={updateConditionInDefinition}
          toUpdate={toUpdate}
        />
      )}
    </React.Fragment>
  );
};
export default BuilderDefinition;
